'use client';

export const SESSION_EXPIRED_EVENT_NAME = 'sus:session-expired';

let hasDispatchedSessionExpiredEvent = false;

/**
 * 세션 만료 이벤트를 전역으로 한 번만 브로드캐스트합니다.
 */
export function notifySessionExpired() {
  if (typeof window === 'undefined') {
    return;
  }

  if (hasDispatchedSessionExpiredEvent) {
    return;
  }

  hasDispatchedSessionExpiredEvent = true;
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT_NAME));
}

/**
 * 재로그인 이후 동일 탭에서 다시 세션 만료를 감지할 수 있도록 상태를 초기화합니다.
 */
export function resetSessionExpiredNotification() {
  hasDispatchedSessionExpiredEvent = false;
}
